<template>
  <!-- # 5.3.5	上清所估值 -->
  <el-container class="main_container w100">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <div class="DataModule full_height">
        <div
          id="box"
          style="width: 100%;height:calc(100vh - 450px); background: #fff"
        ></div>
        <el-row style="overflow-y: auto; height:calc(100vh - 450px);padding: 0 10px 10px 10px;background: #fff;">
          <!-- Revised on 2022-03-05 -->
          <el-table
            id="table"
            :data="table_data"
            border
            style="width: 100%"
            height="100%"
            stripe
            fit
            :header-cell-style="{textAlign: 'center'}"
          >
            <!-- Revised on 2022-03-05 -->
            <el-table-column
              type="index"
              align="center"
              label="idx"
              width="50px"
            />
            <el-table-column
              prop=a0
              align="center"
              :label=row_keys.a0
            />
            <el-table-column
              prop=a1
              align="center"
              :label=row_keys.a1
            />
            <el-table-column
              prop=a2
              align="center"
              :label=row_keys.a2
            />
            <el-table-column
              prop=a3
              align="center"
              :label=row_keys.a3
            />
            <el-table-column
              prop=a4
              align="center"
              :label=row_keys.a4
            />
            <el-table-column
              prop=a5
              align="center"
              :label=row_keys.a5
            />
            <el-table-column
              prop=a6
              align="center"
              :label=row_keys.a6
            />
            <el-table-column
              prop=a7
              align="center"
              :label=row_keys.a7
            />
            <el-table-column
              prop=a8
              align="center"
              :label=row_keys.a8
            />
            <el-table-column
              prop=a9
              align="center"
              :label=row_keys.a9
            />
            <el-table-column
              prop=b0
              align="center"
              :label=row_keys.b0
            />
            <el-table-column
              prop=b1
              align="center"
              :label=row_keys.b1
            />
            <el-table-column
              prop=b2
              align="center"
              :label=row_keys.b2
            />
            <el-table-column
              prop=b3
              align="center"
              :label=row_keys.b3
            />
            <el-table-column
              prop=b5
              align="center"
              :label=row_keys.b5
            />
          </el-table>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import echarts from 'echarts'
import { mapState, mapMutations } from "vuex";
import { get_sh_valuation } from 'common/js/http/v3Api'
import { exportTableData } from 'common/js/utils/utils'

export default {
  name: "sh_valuation",
  data() {
    return {
      row_keys: {
        // "a0":"日期",
        // "a1":"代偿期(年)",
        // "a2":"估价全价（元）",
        // "a3":"应计利息（元）",
        // "a4":"日终估价全价（元）",
        // "a5":"日终应计利息（元）",
        // "a6":"估价净价（元）",
        // "a7":"估价收益率（%）",
        // "a8":"估价修正久期",
        // "a9":"估价凸性",
        // "b0":"估价基点价值",
        // "b1":"剩余本金",
        // "b2":"交易市场",
        // "b3":"可信度",
        // "b5":"特殊估值",
        // "b6":"特殊估值标识（权限控制用）"
        "a0": "date",
        "a1": "Term to maturity (year)",
        "a2": "Full appraisal price (yuan)",
        "a3": "Accrued interest (yuan)",
        "a4": "End of day full price (yuan)",
        "a5": "Accrued interest at the end of the day (yuan)",
        "a6": "Estimated net price (yuan)",
        "a7": "Appraisal yield (%)",
        "a8": "Valuation amendment duration",
        "a9": "Convexity of valuation",
        "b0": "Valuation basis value",
        "b1": "Remaining principal",
        "b2": "Trading market",
        "b3": "reliability",
        "b5": "Special valuation",
        "b6": "Special valuation identification (for authority control)"
      },
      isMobilePhone: false,
      stockCode: '120303.SH',
      table_data: null
    };
  },

  mounted() {
    this.stockCode = this.$route.query.stockCode
    this.get_sh_valuation()
  },
  methods: {
    async get_sh_valuation() {
      const { data } = await get_sh_valuation({
        trd_code: this.stockCode
      });
      const rows = data.result.data.rows;
      this.table_data = rows
      this.draw_box()
    },
    async searchTableData(item) {
      if (item) {
        this.stockCode = item;
        this.get_sh_valuation()
      }
    },
    /* Revised on 2022-03-05 */
    exportTableData() {
      let html = document.getElementById("table").outerHTML.replace(/<(\w+) (.+?)>/g, (m, p1) => `<${p1}>`)
        .replace('<table>', '<table border>')
      // vnd.ms-excel.numberformat:@; 格式化文本
      // xmlns 和 head 中 用于显示网格线
      html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel">
            <head>
              <xml>
                <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                      <x:WorksheetOptions>
                        <x:Print><x:ValidPrinterInfo /></x:Print>
                      </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
            </head>
            <style>
              table{vnd.ms-excel.numberformat:@;}
            </style>
              ${html}
            </html>`
      let blob = new Blob([html], { type: 'application/octet-stream' })
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'sh_valuation.xlsx' // 重命名文件
      link.click()
      window.URL.revokeObjectURL(url) // 释放内存
    },
    /* Revised on 2022-03-05 */
    draw_box() {
      var obj = [];
      var time = [];
      this.table_data.forEach(element => {
        obj.push(element.a2)
        time.push(element.a0)
      });
      var myChart = echarts.init(document.getElementById("box"));
      var option = {
        xAxis: {
          type: 'category',
          data: time.reverse()
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          formatter: (val) => {
            let text='Full appraisal price: ' + val.value + ' (yuan)'
              // let res=`<div>
              // <p style="margin-bottom: 5px">${val[0].name}</p>
              // <span>${this.tabList.filter(item => item.value == this.tabRadio)[0].label}</span>
              // <div style="color: #1B232F; margin-top: 10px">数量 : ${val[0].data}</div>
              // </div>`
              return text
          },
        },
        series: [
          {
            data: obj.reverse(),
            type: 'line'
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
.ismobilePhone {
  padding: 0 !important;
  background: #fff !important;
}
.w100 {
  width: 100%;
}
.el-main {
  padding: 0;
  height: 100%;
}
.full_height {
  overflow-y: auto;
}
.full_height::-webkit-scrollbar {
  display: none;
}
</style>
